$(document).ready(function() {
    // Attach the positionArrow function to the window resize event
    $(window).resize(positionArrow);

    // Combine selectors and attach a single click event handler
    $('#trigger-dropdown-account, #trigger-dropdown-language-chooser, #dropdown-trigger-links-mobile-search').click(function() {
        positionArrow();
        resetToParentMenu();
        removeBodyOverflow();
    });

    // Attach click event handlers on Mobile menu modal trigger element
    $('.menu-bar__trigger-btn').click(function() {
        resetToParentMenu();
        positionMenuModal();
        toggleBodyOverflow();
    });

    // Initial call to positionArrow to handle any pre-expanded states on page load
    positionArrow();

    // Call the initializeMobileMenu function to handle mobile menu behavior
    initializeMobileMenu();

    // Initial arrangement of menu items
    arrangeDesktopMenuItems();

    // Initialize the focus management
    manageFocus();
    manageBackFocus();

    // Call the toggleMenuContentHover function to manage the styling of the hovered menu element
    toggleMenuContentHover();

    // Call the toggleMenuChildOnKeyboard function to handle navigation with tab key
    toggleMenuChildOnKeyboard();

    // Call the focusMenuTab function to manage the styling of the focused menu element
    focusMenuTab();

    submenuTopValue();
});

/**
 * toggleMenuContentHover()
 * Description: Toggle visibility of dropdown menu content on hover for desktop menu, displaying the content
 *              when the user hovers over dropdown tab.
 * Returns: void
 */

function toggleMenuContentHover() {
    $('.desktop-nav__list-item').hover(function() {
        $(this).find('.desktop-nav__child-wrapper').show();
    }, function() {
        $(this).find('.desktop-nav__child-wrapper').hide();
    });
}

/**
 * toggleMenuChildOnKeyboard()
 * Description: Toggle visibility of the child menu wrapper on keyboard navigation for desktop menu, enhancing
 *              accessibility.
 *              Shows the dropdown content when navigating with the Tab key, and opens the menu when Space or Enter
 *              is pressed.
 * Returns: void
 */
function toggleMenuChildOnKeyboard() {
    // Show and hide the child wrapper on menuKeyboard navigation for Desktop menu (Accessibility)
    $('.desktop-nav__list-item .card-divider-button').on('keydown', function(event) {
        if (event.code === 'Space' || event.code === 'Enter') {
            // Prevent the default action
            event.preventDefault();

            // Find the parent .desktop-nav__list-item of the button
            const listItem = $(this).closest('.desktop-nav__list-item');

            // Find the specific child wrapper inside this list item
            const childWrapper = listItem.find('.desktop-nav__child-wrapper');

            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            // Toggle the expanded state
            this.setAttribute('aria-expanded', !isExpanded);

            // Toggle the visibility of the child wrapper
            if (childWrapper.is(':visible')) {
                childWrapper.hide();
                listItem.removeClass('focused-item');
            } else {
                childWrapper.show();
                listItem.addClass('focused-item');
            }
        }
    });
}

/**
 * focusMenuTab()
 * Description: Adds and removes the 'focused' class to the parent .desktop-nav__list-item element
 *              when an <a> or button with the class .card-divider-button gains or loses focus
 *              (for accessibility to meet ECL EC).
 * Returns: void
 */
function focusMenuTab() {
    const focusableElements = $('.desktop-nav__list-item > a, .desktop-nav__list-item > .card-divider-button');

    focusableElements.on('focus', function() {
        // Add 'focused' class to the parent .desktop-nav__list-item
        $(this).closest('.desktop-nav__list-item').addClass('focused');
    });

    focusableElements.on('blur', function() {
        // Remove 'focused' class from the parent .desktop-nav__list-item
        $(this).closest('.desktop-nav__list-item').removeClass('focused');
    });
}

/**
 * positionArrow()
 * Description: Dynamically positions the arrow under the active dropdown icon
 *              based on the current window size and icon state. It checks for
 *              the active state by inspecting the "aria-expanded" attribute of
 *              each dropdown and adjusts the arrow's position using CSS variables
 *              applied to the parent element of the pseudo-element (:before).
 * Returns: void
 */
function positionArrow() {
    // Define the configuration for each icon and its associated dropdown and arrow
    const icons = [
        {
            id: '#trigger-dropdown-account',
            arrowParentSelector: 'header .main-bar__login .dropdown-menu-account > ul',
            dropdownSelector: '.dropdown.dropdown__bottom.main-bar__dropdown'
        },
        {
            id: '#trigger-dropdown-language-chooser',
            arrowParentSelector: 'header .main-bar__language-switcher .main-header__language',
            dropdownSelector: '.main-header__language'
        },
        {
            id: '#dropdown-trigger-links-mobile-search',
            arrowParentSelector: 'header .main-bar__search-mobile__dropdown-inner',
            dropdownSelector: '.main-bar__search-mobile__dropdown-inner'
        }
    ];

    // Iterate through each icon configuration to update the arrow position
    $.each(icons, function(index, icon) {
        const $iconElement = $(icon.id);
        const $arrowParentElement = $(icon.arrowParentSelector);
        const $dropdownElement = $(icon.dropdownSelector);

        // Check if all required elements exist
        if ($iconElement.length && $arrowParentElement.length && $dropdownElement.length) {
            // Check if the icon is expanded by inspecting the aria-expanded attribute
            if ($iconElement.attr('aria-expanded') === 'true') {
                // Calculate the position of the arrow based on the icon and dropdown positions
                const iconRect = $iconElement[0].getBoundingClientRect();
                const dropdownRect = $dropdownElement[0].getBoundingClientRect();
                const arrowLeft = iconRect.left + (iconRect.width / 2) - dropdownRect.left - 10;

                // Apply the calculated position to the arrow using CSS variables
                $arrowParentElement.css({
                    '--arrow-left': arrowLeft + 'px',
                    '--arrow-display': 'block'
                });
            } else {
                // Hide the arrow if the icon is not expanded
                $arrowParentElement.css({
                    '--arrow-display': 'none'
                });
            }
        }
    });
}

/**
 * positionMenuModal()
 * Description: Dynamically positions the top of the Mobile Menu Modal.
 *              This behaviour is required because in some pages like login,
 *              you may have an info bar displayed before the header.
 * Returns: void
 */
function positionMenuModal() {
    const menuBar = $('#menu-bar-container');

    if (menuBar.length) {
        // Get the position of the element
        const rect = menuBar[0].getBoundingClientRect();
        const positionTop = rect.top + $(window).scrollTop();

        // Add the top position value to a CSS variable
        document.documentElement.style.setProperty('--menu-bar-top', `${positionTop}px`);
    }
}

/**
 * initializeMobileMenu()
 * Description: Initializes the mobile menu functionality, handling submenu opening and closing.
 * Returns: void
 */
function initializeMobileMenu() {
    $('.card-divider-button').on('click', function() {
        const submenuId = $(this).data('open');
        $('#mobile-nav__parent').hide();
        $('#' + submenuId).closest('.mobile-nav__child-wrapper').show();
    });

    $('.mobile-nav__back-button').on('click', function() {
        $(this).closest('.mobile-nav__child-wrapper').hide();
        $('#mobile-nav__parent').show();
    });
}

/**
 * resetToParentMenu()
 * Description: Resets the mobile menu view to the parent menu.
 * Returns: void
 */
function resetToParentMenu() {
    $('.mobile-nav__child-wrapper').hide();
    $('#mobile-nav__parent').show();
}

/**
 * arrangeDesktopMenuItems()
 * Description: Initializes the desktop navigation menu by handling hover behavior, setting column layouts based
 * on item count, and ensuring proper structure for child items.
 * Returns: void
 */
function arrangeDesktopMenuItems() {
    $(".desktop-nav__list-item").hover(
        function () {
            const $wrapper = $(this).find(".desktop-nav__child-wrapper");

            if ($wrapper.length > 0) {
                if ($wrapper.data("position-adjusted")) return; // Prevent re-execution

                $wrapper.css("display", "block");

                setTimeout(() => {
                    const wrapperOffset = $wrapper.offset().left;

                    if (!$wrapper.data("position-set")) { // Only adjust once
                        adjustMenuPosition($wrapper, wrapperOffset);
                        $wrapper.data("position-set", true);
                    }
                }, 5);
            }
        },
        function () {
            $(this).find(".desktop-nav__child-wrapper")
                .css("display", "none");
        }
    );

    $(".desktop-nav__child-wrapper").each(function () {
        const $wrapper = $(this);
        const $items = $wrapper.find(".desktop-nav__child-item");
        const itemCount = $items.length;
        const $childList = $wrapper.find(".desktop-nav__child-list");

        const columnClass =
            itemCount < 5 ? "desktop-nav__item--col1" :
                itemCount < 9 ? "desktop-nav__item--col2" :
                    itemCount < 13 ? "desktop-nav__item--col3" :
                        "desktop-nav__item--full";

        $wrapper.addClass(columnClass);

        if ($items.length > 0 && !$childList.children().length) {
            $items.appendTo($childList);
        }
    });
}

/**
 * adjustMenuPosition()
 * Description: Adjusts the dropdown menu’s position to prevent overflow by switching between left-to-right and right-to-left alignment dynamically.
 * Returns: void
 */
function adjustMenuPosition($wrapper, wrapperOffset) {
    const menuWidth = $wrapper.outerWidth();
    const containerWidth = $(".desktop-nav").outerWidth();
    const documentWidth = $(window).width(); // Viewport width
    const wrapperRight = documentWidth - (wrapperOffset + menuWidth);

    if (wrapperOffset < 0) {
        $wrapper.removeClass("left-auto right-0").addClass("left-0 right-auto");
        return;
    }

    if (wrapperRight < 0) {
        $wrapper.removeClass("left-0 right-auto").addClass("left-auto right-0");
        return;
    }

    const newClass = (menuWidth < documentWidth / 2 && wrapperOffset + menuWidth > containerWidth)
        ? "left-0 right-auto"
        : (menuWidth < documentWidth / 2)
            ? "left-auto right-0"
            : "left-auto right-auto";

    $wrapper.removeClass("left-auto right-0 left-0 right-auto").addClass(newClass);
}

// Run the function when the DOM is ready
$(document).ready(arrangeDesktopMenuItems);

/**
 * toggleBodyOverflow()
 * Description: Toggles the body overflow style based on the aria-expanded attribute of the menu-bar__trigger-btn.
 * Returns: void
 */
function toggleBodyOverflow() {
    const triggerBtn = $('.menu-bar__trigger-btn');

    if (triggerBtn.attr('aria-expanded') === 'true') {
        $('body').css('overflow', 'hidden');
    } else {
        $('body').css('overflow', '');
    }
}

/**
 * removeBodyOverflow()
 * Description: Removes the body overflow hidden style.
 * Returns: void
 */
function removeBodyOverflow() {
    $('body').css('overflow', '');
}

/**
 * focusElement()
 * Description: Helper function to verify the existence of an element before setting focus on it.
 * Returns: void
 */
function focusElement(element) {
    const focusInterval = setInterval(() => {
        if (element) {
            element.focus();
            clearInterval(focusInterval);
        }}, 50);
}

/**
 * manageFocus()
 * Description: Manages the focus between the trigger button and the first navigation link on Mobile.
 * Returns: void
 */
function manageFocus() {
    // Select the first link inside ul#mobile-nav__parent
    const firstNavLink = $('#mobile-nav__parent > li:first-of-type > a');
    const triggerBtn = $('.menu-bar__trigger-btn');
    const subMenuBtn = $('.mobile-nav__list-item > .card-divider-button')
    const firstSubMenuLink = $('.mobile-nav__child-wrapper > .mobile-nav__list-child > li:first-of-type > a');

    // Verify if the elements are correctly selected
    if (firstNavLink.length > 0 && triggerBtn.length > 0) {
        // Add keydown event listener to firstNavLink
        firstNavLink.on('keydown', function(event) {
            if (event.shiftKey && event.key === 'Tab') {
                // Focus the header button when Shift + Tab is pressed
                triggerBtn.focus();
                event.preventDefault();
            }
        });

        // Add keydown event listener to triggerBtn
        triggerBtn.on('keydown', function(event) {
            if (!event.shiftKey && event.key === 'Tab') {
                // Check if the modal is open
                if (triggerBtn.attr('aria-expanded') === 'true') {
                    firstNavLink.focus();
                }
            } else if (event.code === 'Space' || event.code === 'Enter') {
                //Focus the first navigation link when the menu is opened
                focusElement(firstNavLink);
            }
        });

        subMenuBtn.on('keydown', function(event) {
            if (event.code === 'Space' || event.code === 'Enter') {
                //Focus the first navigation link when the submenu is opened
                focusElement(firstSubMenuLink);
            }
        })
    }
}

/**
 * manageBackFocus()
 * Description: Restore focus to the previously selected item when the 'Back' link is clicked.
 * Returns: void
 */
function manageBackFocus() {
    const firstNavLink = $('#mobile-nav__parent > li:first-of-type > a');
    const triggerBtn = $('.menu-bar__trigger-btn');
    const subMenuBtn = $('.mobile-nav__list-item > .card-divider-button');
    const backButton = $('.mobile-nav__child-wrapper > .mobile-nav__back-button');

    // Verify if the elements are correctly selected
    if (firstNavLink.length > 0 && triggerBtn.length > 0) {

        let lastFocusedButton = null;

        // Add focus event listener to all buttons
        document.querySelectorAll('.card-divider-button').forEach(button => {
            button.addEventListener('focus', (event) => {
                lastFocusedButton = event.target;
            });
        });

        backButton.on('keydown', function(event) {
            if (event.code === 'Space' || event.code === 'Enter') {
                const buttonToFocus = document.querySelector(`.card-divider-button[data-open="${lastFocusedButton.dataset.open}"]`);

                //Set focus on the last active menu element when the 'Back' button is pressed.
                focusElement(buttonToFocus);
            }
        });
    }
}


// Measure the width of the menu container and the combined width of its items.
// Display only the items that fit within the container's width.
// Move any overflow items to the next slide for navigation.
const container = document.querySelector('.desktop-nav__parent-wrapper');
const items = document.querySelectorAll('.desktop-nav__list-item');
const nextBtn = document.getElementById('next-scroll-button');
const prevBtn = document.getElementById('previous-scroll-button');

let pages = [];
let currentPage = 0;

function paginateMenuItems() {
    const containerWidth = container.offsetWidth;
    let currentWidth = 0;
    let currentPageItems = [];

    pages = []; // reset

    items.forEach((item) => {
        const itemWidth = item.offsetWidth;

        if (currentWidth + itemWidth > containerWidth && currentPageItems.length > 0) {
            pages.push(currentPageItems);
            currentPageItems = [item];
            currentWidth = itemWidth;
        } else {
            currentPageItems.push(item);
            currentWidth += itemWidth;
        }
    });

    if (currentPageItems.length) {
        pages.push(currentPageItems);
    }

    currentPage = 0;
    updateVisibleItems();
}

function updateVisibleItems() {
    items.forEach(item => item.style.display = 'none');
    pages[currentPage].forEach(item => item.style.display = '');

    prevBtn.style.display = currentPage > 0 ? 'flex' : 'none';
    nextBtn.style.display = currentPage < pages.length - 1 ? 'flex' : 'none';
}

nextBtn.addEventListener('click', () => {
    if (currentPage < pages.length - 1) {
        currentPage++;
        updateVisibleItems();
    }
});

prevBtn.addEventListener('click', () => {
    if (currentPage > 0) {
        currentPage--;
        updateVisibleItems();
    }
});


let resizeTimeout;

window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout); // Cancel previous timeout if still waiting
    resizeTimeout = setTimeout(() => {
        paginateMenuItems();
    }, 200);
});
window.addEventListener('load', paginateMenuItems);


// Get the height of the menu item.
// Set the submenu's top position equal to the menu item's height.
function submenuTopValue() {
    const itemHeight = $('.desktop-nav__list-item').outerHeight(); // Get height in pixels

    const subItems = document.getElementsByClassName('desktop-nav__child-wrapper');
    for (let i = 0; i < subItems.length; i++) {
        subItems[i].style.top = itemHeight + 'px'; // Set top position
    }
}
